"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaCoinChangeToJSON = exports.RosettaCoinChangeFromJSONTyped = exports.RosettaCoinChangeFromJSON = exports.RosettaCoinChangeCoinActionEnum = void 0;
const _1 = require("./");
/**
* @export
* @enum {string}
*/
var RosettaCoinChangeCoinActionEnum;
(function (RosettaCoinChangeCoinActionEnum) {
    RosettaCoinChangeCoinActionEnum["created"] = "coin_created";
    RosettaCoinChangeCoinActionEnum["spent"] = "coin_spent";
})(RosettaCoinChangeCoinActionEnum = exports.RosettaCoinChangeCoinActionEnum || (exports.RosettaCoinChangeCoinActionEnum = {}));
function RosettaCoinChangeFromJSON(json) {
    return RosettaCoinChangeFromJSONTyped(json, false);
}
exports.RosettaCoinChangeFromJSON = RosettaCoinChangeFromJSON;
function RosettaCoinChangeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'coin_identifier': _1.RosettaAccountBalanceResponseCoinIdentifierFromJSON(json['coin_identifier']),
        'coin_action': json['coin_action'],
    };
}
exports.RosettaCoinChangeFromJSONTyped = RosettaCoinChangeFromJSONTyped;
function RosettaCoinChangeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'coin_identifier': _1.RosettaAccountBalanceResponseCoinIdentifierToJSON(value.coin_identifier),
        'coin_action': value.coin_action,
    };
}
exports.RosettaCoinChangeToJSON = RosettaCoinChangeToJSON;
//# sourceMappingURL=RosettaCoinChange.js.map